var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1665 8C13.1665 7.72386 12.9426 7.5 12.6665 7.5H3.33317C3.05703 7.5 2.83317 7.72386 2.83317 8C2.83317 8.27614 3.05703 8.5 3.33317 8.5H12.6665C12.9426 8.5 13.1665 8.27614 13.1665 8Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97962 4.31319C8.78436 4.50846 8.78436 4.82504 8.97962 5.0203L12.313 8.35363C12.5082 8.5489 12.8248 8.5489 13.0201 8.35363C13.2153 8.15837 13.2153 7.84179 13.0201 7.64653L9.68672 4.31319C9.49146 4.11793 9.17488 4.11793 8.97962 4.31319Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0201 7.64645C12.8248 7.45118 12.5082 7.45118 12.313 7.64645L8.97962 10.9798C8.78436 11.175 8.78436 11.4916 8.97962 11.6869C9.17488 11.8821 9.49146 11.8821 9.68672 11.6869L13.0201 8.35355C13.2153 8.15829 13.2153 7.84171 13.0201 7.64645Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon-arrow-right.824cbfa995d4391f40663b584b6c69ad.svg";
export { ForwardRef as ReactComponent };